// extracted by mini-css-extract-plugin
module.exports = {"page":"signIn_page__1NqJO","form":"signIn_form__3Le6I","agreeButton":"signIn_agreeButton__2yFd8","inputIcon":"signIn_inputIcon__24oPl","logo":"signIn_logo__1M1EA"};